export default __webpack_public_path__ + "static/media/February2018.409eb015.png";